export const PAYMENT_NOT_AVAILABLE_TEXT = 'Payment not available';

export const DEALER_CASH = 'Dealer Cash';

export const NEGOTIABLE_LABEL = 'My Asking Price';
export const SINGLE_PRICE_LABEL = 'My Price';
export const MY_OFFER_PRICE_LABEL = 'My Offer Price';

export const IS_TERMID_WITH_DOWNPAYMENT = 'isTermIdWithDownPayment';

export const SHOPPER_LOCATION_CHANGE_META = 'isShopperLocationChange';

export const SPACE_DELIMITER = ' ';

export const REQUESTED_DOWN_PAYMENT_FIELD_NAME = 'requestedDownPayment';

export const CASH_DOWN_FIELD_NAME = 'dueAtSigning';

/** Feature toggle for the ASP payment grid redesign. */
export const ASP_PG_REDESIGN_TOGGLE = 'F298789_ASP_PG_redesign';
export const PAYMENT_GRID_PERSISTENCE_TOGGLE = 'F324220_Enable_Payment_Grid_Persistence';
export const MULTI_SCENARIO_GRID_CONSISTENCY_TOGGLE = 'DE774740_Enable_Multi_Scenario_Grid_Consistency';
export const TEMPLATE_RATE_UPQ_LOCK_TOGGLE = 'F325266_Enable_Template_Rate_Upq_Lock';

export const SV_RETAIN_PROGRAM_TOGGLE = 'F311786_SV_Retain_Program';

export const EXPLICIT_LENDER_P1_TOGGLE = 'enableExplicitLenderP1';

/**
 * F302921 / US2041815 - persisting the compressed payment grid to the deal baggage.
 *
 * Re-exported from the shared package rather than spelt out again. The same flag gates the write path,
 * both reading applications and this middleware's stamping; a copy per package means a rename during
 * rollout has to land in each one, and a typo in any of them silently switches off that half.
 */
export { PAYMENT_GRID_BAGGAGE_COMPRESSION_TOGGLE } from '@makemydeal/dr-platform-shared';

/**
 * A calculation-endpoint change coming from the Auto Select Program checkbox. A copy of
 * `CDL_USER_INTENT.ASP_CHECKBOX_TOGGLED` in dash-store, which sets it: dash-store depends on this package, so it
 * cannot be imported the other way round. A dash-store spec asserts the pair still matches.
 */
export const ASP_CHECKBOX_TOGGLED_INTENT = 'asp-checkbox-toggled';

/**
 * A sell-rate override typed into a payment-grid column, as opposed to written by the deal screen, a template restore or
 * a deal reload. A copy of `CDL_USER_INTENT.PAYMENT_GRID_SELL_RATE`, for the same reason as above.
 *
 * The distinction is load-bearing: `overridesByTerm[term].sellRate` is a general per-term slot with many writers, so its
 * presence does not mean the user priced that column.
 */
export const PAYMENT_GRID_SELL_RATE_INTENT = 'payment-grid-sell-rate';

/**
 * A residual typed into a payment-grid column. Copy of `CDL_USER_INTENT.PAYMENT_GRID_RESIDUAL`, and load-bearing for the
 * same reason as the sell rate above: `overridesByTerm[term].residualInfo` has many writers, so its presence alone does
 * not mean the user priced that column.
 */
export const PAYMENT_GRID_RESIDUAL_INTENT = 'payment-grid-residual';

/**
 * The remaining two intents the payment grid's own inputs and cells carry. Copies of
 * `CDL_USER_INTENT.PAYMENT_GRID_TEXT_ENTRY` / `PAYMENT_GRID_CELL_SELECTED`, for the same reason as above.
 */
export const PAYMENT_GRID_TEXT_ENTRY_INTENT = 'payment-grid-text-entry';
export const PAYMENT_GRID_CELL_SELECTED_INTENT = 'payment-grid-cell-selected';

export const DEAL_HYDRATION_INTENT = 'deal-hydration';

export const GRID_AXIS_EDIT_INTENT = 'payment-grid-axis-edit';

/**
 * The intents that mean "this edit was made INSIDE the grid". `gridAction` cannot say it: every payment action is fanned
 * out into row calls stamped with it while the grid is open. The grid's own inputs and cells carry one of these.
 */
export const PAYMENT_GRID_USER_INTENTS: ReadonlySet<string> = new Set([
    PAYMENT_GRID_SELL_RATE_INTENT,
    PAYMENT_GRID_RESIDUAL_INTENT,
    PAYMENT_GRID_TEXT_ENTRY_INTENT,
    PAYMENT_GRID_CELL_SELECTED_INTENT
]);
